<style >
.modal-edit-task-dod{
  overflow-y: auto !important;
}
.modal-edit-task-dod{
  width: 90vw;
  height: 90vh !important;
}
.modal-edit-task-dod textarea{
  height: 60vh;
}
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position modal-edit-task-dod">
    <div class="card mb-4">
      <div class="card-body p-3">
        <h4>Modifica DOD</h4>
        <p>{{ selectedTask.actualDod }}</p>
        <textarea
            @input="updateDesc($event.target.value)"
            class="form-control mb-5" :value="selectedTask.descrizione" >
        </textarea>
        <div class="d-flex justify-content-end">
          <button @click="annulla" class="btn btn-outline-secondary btn-sm m-0 me-2">
            Annulla
          </button>
          <button @click="confermaModifica" class="btn btn-primary btn-sm m-0 me-2">
            Conferma modifica
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as $ from 'jquery';
  export default {
    name: "KModalEditTask",

    data(){
      return{
        selectedTask:{},
        show:false
      }
    },
    created() {
      $(document).keyup(function(e) {
        if (e.key === "Escape" && this.show) {
          this.annulla();
        }
      }.bind(this));

      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'editTaskDOD') {
          this.show=true;
          this.selectedTask=mutation.payload;
          this.selectedTask.actualDod=this.selectedTask.descrizione;
        }
        if(mutation.type==='dodEdited'||mutation.type==='tasksUpdated'){
          this.annulla()
        }
      });
    },
    methods:{
      async confermaModifica(){
        let data={
          descrizione:this.selectedTask.descrizione,
          idTicket:this.selectedTask.idTicket,
          idTaskSprint:this.selectedTask.id
        };
        this.$store.dispatch("updateDOD",data);
      },
      updateDesc(val){
        this.selectedTask.descrizione=val;
      },
      annulla(){
        this.show=false;
        this.selectedTask={}
      }
    }
  }
</script>